import React from "react";

function PageLoader() {
  return (
    <div>
      <p>Loading...</p>
    </div>
  );
}

export default PageLoader;
